import { PALETTE } from "@/composables/chartPalette";
import type { Fill } from "./complianceGroupsTypes";

/**
 * Semantic fills used by every strip, bar and grid in the demo. Adjacent states differ in
 * lightness (forest ladder) so the visuals survive CVD and grayscale, matching chartPalette.
 */
export const FILL: Record<Fill, string> = {
  cancelled: PALETTE.sequentialForest[0], // #0D2218
  inAccount: PALETTE.sequentialForest[1], // #1F4D33
  expected: PALETTE.sequentialForest[3], // #7BA37E
  shortfall: "var(--phoenix-orange-300)",
  actualFeed: PALETTE.sequentialForest[0],
  actualReported: PALETTE.role.focalSoft, // #6A8A73
  estimateOverdue: PALETTE.role.envelopeLo, // #C08E3A
  estimateFuture: PALETTE.role.priceNoData, // #E2E4E2
  metered: "var(--phoenix-gray-700)",
  estimated: "var(--phoenix-gray-300)",
  surplus: PALETTE.sequentialForest[3],
  empty: "var(--phoenix-gray-100)",
};
